import React from 'react'
import { Dimmer, Image, Segment,Button } from 'semantic-ui-react'
import Header from "../../components/Header"
import Footer from "../Home/Footer"
const Nothing = () => (
	<div>
	<Header/>
  <Dimmer.Dimmable as={Segment} dimmed style={{height:100+"%"}}>
    <Dimmer simple>
    <p style={{paddingTop:230}}><h1>"Page not found"</h1></p>
    <p><a href="/"><Button positive>Go Back Home</Button></a></p>
    </Dimmer>
    <p>
      <Image src='https://media.swncdn.com/cms/CW/faith/36236-raining-umbrella-sad-pexels.1200w.tn.jpg' />
    </p>
  </Dimmer.Dimmable>
  <Footer />
  </div>
)

export default Nothing


// WEBPACK FOOTER //
// ./src/views/404/Nothing.js